import { Component, createRef } from 'react'
import { API } from 'aws-amplify'
import TopMenu from '../components/topMenu'
import withRouter from '../components/withRouter'
import Carousel from 'react-bootstrap/Carousel'
import Form from "react-bootstrap/Form"
import Logo from '../images/GigLoca_Logo_Light.png'
import { FaArrowLeft, FaMobileAlt } from 'react-icons/fa'
import { FaFilterCircleXmark } from 'react-icons/fa6'
import { TbDeviceIpadHorizontalSearch, TbWorldWww } from 'react-icons/tb'
import './node.css'

class DYKs extends Component {
    constructor(props) {
        super(props)

        this.state = {
            dyk: null,
            dyks: [],
            filtered: null,
            search: '',
            web: true,
            native: true,
            fan: true,
            venue: true,
            contributor: true
        }

        this.handleOnNotificationsSelect = this.handleOnNotificationsSelect.bind(this)
        this.handleDisplaySettings = this.handleDisplaySettings.bind(this)
        this.handleModeChange = this.handleModeChange.bind(this)
    }

    ScrollTop = createRef()

    componentDidMount() {
        const headers = { Authorization: `Basic VSQzcm5hbWU6UGEkc3dvcmQ=` }
        API.get('lt', `card/dyks`, { headers })
            .then(resp => {
                this.setState({ dyks: resp.data || [] })
            })
            .catch(err => {
                //const { navigate } = this.props
                //navigate(`/`)
                console.log(err)
            })
    }

    scrollToRef = ref => {
        ref.current.scroll({
            top: 0,
            behavior: 'smooth'
        })
    }

    handleNavigate(page) {
        const { navigate } = this.props
        navigate(`/${page}`)
    }

    handleBack() {
        this.props.onBack()
    }

    handleModeChange(mode) {
        if (mode) {
            if (mode === 'contactus' || mode === 'dyks') {
                this.handleNavigate(mode)
            } else if (mode === 'tix') {
                this.handleNavigate('tixcheck')
            } else if (mode !== 'fan') {
                this.props.setMode(mode)
                this.handleNavigate(`my/${mode === 'Venue' ? 'venues' : 'contributors'}`, true)
            } else {
                this.props.setMode(mode)
                this.handleNavigate('', true)
            }
        }
        this.setState({ displaySettings: false })
    }

    handleDisplaySettings() {
        this.setState({ displaySearch: false, displaySettings: !this.state.displaySettings })
    }

    handleOnNotificationsSelect() {
        this.handleNavigate('notifications', true)
    }

    handleSearch = event => {
        let search = event.target.value.replace(/[^\W\D]/g, "")
        this.setState({
            search,
            filtered: search.length > 0 && this.state.dyks.length > 0 ? this.state.dyks.filter(dyk => dyk.title.toLowerCase().indexOf(search.toLowerCase()) > -1) : null
        })
    }

    handlePlatformChanged(platform) {
        this.setState({ [platform]: !this.state[platform] })
    }

    handleSelect(dyk) {
        this.setState({ dyk })
        this.scrollToRef(this.ScrollTop)
    }

    handleOK() {
        this.setState({ dyk: null })        
        this.scrollToRef(this.ScrollTop)
    }

    handleClear() {
        this.setState({ search: '', filtered: null })
    }

    getDYKs() {
        return <div className='Node-Row Node-Flex-Wrap'>
            {this.state.dyks.filter(d => (this.state.native && d.target === 'native') || (this.state.web && d.target === 'web')).filter(d => (this.state.fan && d.type === 'fan') || (this.state.venue && d.type === 'venue') || (this.state.contributor && d.type === 'contributor')).map((dyk, dykidx) => {
                return <div key={`dyk-${dykidx}`} className={`DYK-Item${this.state.dyk && this.state.dyk.id === dyk.id ? ' DYK-Item-Selected' : ''} Node-${dyk.type}`} onClick={() => this.handleSelect(dyk)}>
                    <div className='DYK-Item-Title'>{dyk.title}</div>
                    <div className='DYK-Item-Platform'>Platform: <span style={{ marginRight: '5px' }}>{dyk.target === 'native' ? 'Mobile App' : 'Web App'}</span>{dyk.target === 'native' ? <FaMobileAlt /> : <TbWorldWww />}</div>
                </div>
            })}
        </div>
    }

    getSearch() {
        return <div className='Node-Row Node-Flex-Wrap'>
            {this.state.filtered.filter(d => (this.state.native && d.target === 'native') || (this.state.web && d.target === 'web')).filter(d => (this.state.fan && d.type === 'fan') || (this.state.venue && d.type === 'venue') || (this.state.contributor && d.type === 'contributor')).map((dyk, dykidx) => {
                return <div key={`search-${dykidx}`} className={`DYK-Item${this.state.dyk && this.state.dyk.id === dyk.id ? ' DYK-Item-Selected' : ''}`} onClick={() => this.handleSelect(dyk)}>
                    <div className='DYK-Item-Title'>{dyk.title}</div>
                    <div className='DYK-Item-Platform'>Platform: <span style={{ marginRight: '5px' }}>{dyk.target === 'native' ? 'Mobile App' : 'Web App'}</span>{dyk.target === 'native' ? <FaMobileAlt /> : <TbWorldWww />}</div>
                </div>
            })}
        </div>
    }

    getDYK() {
        return <div className='Node-Row Node-Flex-Wrap'>
            <div className="Node-Row Node-Title" style={{ color: "#fff", textAlign: 'center' }}>{this.state.dyk && this.state.dyk.title ? this.state.dyk.title : ''}</div>
            {this.state.dyk && this.state.dyk.img && this.state.dyk.img.length > 0 ? <div><div className='Node-Row' style={{ marginBottom: '10px' }}><Carousel style={{height: 'auto'}} className='DYK-Carousel' controls={this.state.dyk.img.length > 1} touch={true} indicators={this.state.dyk.img.length > 1} interval={2000} prevLabel={null} nextLabel={null} fade>
                {
                    this.state.dyk.img.map((ci, imgidx) => {
                        return <Carousel.Item key={`ci-${imgidx}`}>
                            <img src={`https://localtalent-upload.s3.amazonaws.com/public/${ci}`} style={{height: 'auto'}} className='DYK-CI' alt={this.state.dyk.msg && this.state.dyk.msg[imgidx] ? this.state.dyk.msg[imgidx] : ''} />
                            {this.state.dyk.msg && this.state.dyk.msg[imgidx] && <Carousel.Caption>{this.state.dyk.msg && this.state.dyk.msg[imgidx] ? <h2>{this.state.dyk.msg[imgidx]}</h2> : null}</Carousel.Caption>}
                        </Carousel.Item>
                    })
                }
            </Carousel></div>
                <div className="Node-Row Info-Flex-Wrap">
                    <div className='Info-Button Info-Button-Save' onClick={() => this.handleOK()}>Got It!</div>
                </div>
            </div> : null}
        </div>
    }

    render() {
        //console.log(this.state, this.props)
        return <div className='Node-Container Node-Black'>
            <TopMenu
                mode='dyks'
                onMode={this.handleModeChange}
                user={this.props.user ? { firstName: this.props.user.firstName, image: this.props.user.image } : null}
                onSettings={this.handleDisplaySettings}
                displaySettings={this.state.displaySettings}
                notifications={this.props.user ? (this.props.user.notifications && this.props.user.notifications.length > 0 ? this.props.user.notifications.length : true) : null}
                onNotifications={this.handleOnNotificationsSelect} />
            <div className='Node-Row Node-Flex-Spread'>
                <div className='Node-Arrow' onClick={() => this.handleBack()}>
                    <div style={{ marginTop: '-13px' }}><FaArrowLeft /></div>
                </div>
                <div><img className='Calendar-Logo' src={Logo} alt='Gigloca' /></div>
            </div>
            <div className='DYK-Header'>Did You Know Library</div>
            <div className='Node-Row Node-Flex-Wrap'><div style={{ width: 'auto', cursor: 'pointer' }} className='Search-Flex'>
                <Form.Check style={{ fontSize: '12pt', margin: '5px' }} type='checkbox' id='native' label='Mobile App' checked={this.state.native} onChange={() => this.handlePlatformChanged('native')} />
                <Form.Check style={{ fontSize: '12pt', margin: '5px' }} type='checkbox' id='web' label='Web App' checked={this.state.web} onChange={() => this.handlePlatformChanged('web')} />
                <Form.Check style={{ fontSize: '12pt', margin: '5px' }} type='checkbox' id='fan' label='Fans' checked={this.state.fan} onChange={() => this.handlePlatformChanged('fan')} />
                <Form.Check style={{ fontSize: '12pt', margin: '5px' }} type='checkbox' id='venue' label='Venues' checked={this.state.venue} onChange={() => this.handlePlatformChanged('venue')} />
                <Form.Check style={{ fontSize: '12pt', margin: '5px' }} type='checkbox' id='contributor' label='Contributors' checked={this.state.contributor} onChange={() => this.handlePlatformChanged('contributor')} />
            </div></div>
            <div className='Node-Row Node-Flex-Wrap'>
                <div className='Node-Flex'>
                    <div>
                        <Form.Group controlId="search" className="form-group form-group-lg">
                            <Form.Label style={{fontSize: '16pt'}} className='Pref-Label'><span style={{ marginRight: '5px' }}>DYK Search</span><TbDeviceIpadHorizontalSearch /></Form.Label>
                            <Form.Control
                                placeholder='Search Library'
                                type="text"
                                value={this.state.search}
                                onChange={this.handleSearch}
                            />
                        </Form.Group></div>
                    <div className='Pref-Label' onClick={() => this.handleClear()}><FaFilterCircleXmark /></div>
                </div></div>
            <div ref={this.ScrollTop} className='DYK-View-Container'>
                {this.state.dyk && this.getDYK()}
                {this.state.filtered && this.getSearch()}
                {this.state.dyks.length > 0 && !this.state.filtered && this.getDYKs()}
            </div>
        </div>
    }
}

export default withRouter(DYKs)